(function($){
  $(document).ready(function(){

    // product gallery
    if ( $('.segment-products-slider > .gb-inside-container').length) {

      var html = $('.segment-products-slider > .gb-inside-container')[0].innerHTML;
      var thumbnail_html = $('<div></div>').addClass('thumbnail-slider-wrp').addClass('gb-inside-container').html(html);

      $('.segment-products-slider > .gb-inside-container').addClass('products-slider-wrp');

      $('.segment-products-slider').append(thumbnail_html);

      $('.segment-products-slider > .products-slider-wrp').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        asNavFor: '.segment-products-slider > .thumbnail-slider-wrp'
      }); 

      $('.segment-products-slider > .thumbnail-slider-wrp').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        asNavFor: '.segment-products-slider > .products-slider-wrp',
      }); 
    }

    // atsls logo slider
    if ( $('.atsls-logo-slider').length) {

      $('.atsls-logo-slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }]
      }); 
    }

    $(document).on("click",".atsls-tabs-section [data-tab]",function() {
      const element = $(this);
      const tabID = element.data('tab');

      const tabContent = $(`.atsls-tabs-section [data-tab-content="${tabID}`);

      const currentElement = $(`.atsls-tabs-section [data-tab].activeTab`);
      const currentTab = $(`.atsls-tabs-section [data-tab-content].active`);


      element.addClass('activeTab');
      currentElement.removeClass('activeTab');
      currentTab.removeClass('active').hide();
      tabContent.addClass('active').show();

    });


    // Product Gallery Block
    if ( $('.atsls-product-gallery .product-wrp .main-slider-wrp').length) {
      $('.atsls-product-gallery .product-wrp .main-slider-wrp').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        fade: true,
        cssEase: 'linear',
        asNavFor: '.product-wrp .thumbnail-slider-wrp'
      });
    }

    if ( $('.atsls-product-gallery .product-wrp .thumbnail-slider-wrp').length) {
      $('.atsls-product-gallery .product-wrp .thumbnail-slider-wrp').slick({
        slidesToShow: 8,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        asNavFor: '.product-wrp .main-slider-wrp'
      });
    }

    if ( $('.atsls-product-gallery .product-modal .main-slider-wrp').length) {
      $('.atsls-product-gallery .product-modal .main-slider-wrp').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        fade: true,
        cssEase: 'linear',
        asNavFor: '.product-modal .thumbnail-slider-wrp'
      });
    }

    if ( $('.atsls-product-gallery .product-modal .thumbnail-slider-wrp').length) {
      $('.atsls-product-gallery .product-modal .thumbnail-slider-wrp').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        vertical: true,
        asNavFor: '.product-modal .main-slider-wrp'
      });
    }

    // Teams slider
    if ( $('.atsls-teams-slider .teams-wrp .main-slider-wrp').length) {
        $('.atsls-teams-slider .teams-wrp .main-slider-wrp').not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3000,
          infinite: true,
          arrows: true,
          dots: false,
          fade: true,
          cssEase: 'linear',
          asNavFor: '.atsls-teams-slider .teams-wrp .thumbnail-slider-wrp'
        });
      }

      if ( $('.atsls-teams-slider .teams-wrp .thumbnail-slider-wrp').length) {
        $('.atsls-teams-slider .teams-wrp .thumbnail-slider-wrp').not('.slick-initialized').slick({
          slidesToShow: 8,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3000,
          infinite: true,
          arrows: false,
          dots: false,
          focusOnSelect: true,
          asNavFor: '.atsls-teams-slider .teams-wrp .main-slider-wrp',
          responsive: [{
            breakpoint: 992,
            settings: {
              slidesToShow: 6
            }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 4
            }
          }]
        });
      }


    $('.atsls-product-gallery .product-wrp .slider-wrapper .full-screen').click(function() {
      $('.atsls-product-gallery .product-modal').addClass('modal-show');
    });

    $('.atsls-product-gallery .product-modal .close-btn').click(function() {
      $('.atsls-product-gallery .product-modal').removeClass('modal-show');
    });

    // atsls modal
    $('.atsls-modal').each(function() {
      $(this).find('.gb-inside-container').append('<div class="close-btn"></div>');
    });

    $('.atsls-modal-btn').click(function(e) {
      var data_id = $(this).attr('data-id');

      if ($('.atsls-modal[data-id="' + data_id + '"]').length) {
        $('.atsls-modal[data-id="' + data_id + '"]').addClass('modal-show');
      }
      // return false;
      e.preventDefault(); 
    });

    $('.atsls-modal .gb-inside-container .close-btn').click(function() {
     $(this).parent().parent().removeClass('modal-show');
    });

    window.addEventListener('click', function(e){   

      if( $('.atsls-modal').length ) {

        $('.atsls-modal').each(function() {

          var data_id = $(this).attr('data-id');

          if ( $(this).hasClass('modal-show') && !$('.atsls-modal-btn[data-id="' + data_id + '"]')[0].contains(e.target) ) {
            if ($(this).find('.gb-inside-container')[0].contains(e.target) ){
              // Clicked in box
            } else{
              $(this).removeClass('modal-show');
            }
          }

        });
      }
        
    });

    // ATSLS hero slider
    if ( $('.atsls-hero-slider .slider-wrp').length) {
      $('.atsls-hero-slider .slider-wrp').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        arrows: true,
        dots: true,
        fade: true,
        cssEase: 'linear'
      });

      // $('.atsls-hero-slider .slider-wrp .each.slick-current.slick-active').each(function(){

      //   var autoplaySpeed = $(this).attr('data-slick-autoplay');
        
      //   if( !autoplaySpeed ) {
      //     autoplaySpeed = 3000;
      //   }

      //   $('.atsls-hero-slider .slider-wrp').slick('unslick');

      //   $('.atsls-hero-slider .slider-wrp').slick({
      //     slidesToShow: 1,
      //     slidesToScroll: 1,
      //     autoplay: true,
      //     autoplaySpeed: autoplaySpeed,
      //     infinite: true,
      //     arrows: true,
      //     dots: true,
      //     fade: true,
      //     cssEase: 'linear'
      //   });

      // });

      // $('.atsls-hero-slider .slider-wrp').on('beforeChange', function(event, slick, currentSlide, nextSlide){

      //   var autoplaySpeed = $(slick.$slides[nextSlide]).attr('data-slick-autoplay');
        
      //   if( !autoplaySpeed ) {
      //     autoplaySpeed = 3000;
      //   }

      //   slick.slickSetOption({
      //     autoplaySpeed: autoplaySpeed
      //   }, true);

      // });
    }

    // suotertrak logo slider
    if ( $('.supertrak-logo-slider').length) {

      $('.supertrak-logo-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }]
      }); 
    }


    // number countup
    function animateValue(obj) {
      let startTimestamp = null;
      let start = 0;

      let inner_html = obj.innerHTML;
      let result = inner_html.replace(',', '').replace(' ', '').replace('+', '').replace('M', '').replace('B', '').replace('%', '').replace('K', '');

      let end = Number(result);
      let duration = 1500;

      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);

        if (inner_html.includes('+')) {
          obj.innerHTML = Math.floor(progress * (end - start) + start) + '+';
        } else if (inner_html.includes('M')) {
          obj.innerHTML = Math.floor(progress * (end - start) + start) + 'M';
        } else if (inner_html.includes('B')) {
          obj.innerHTML = Math.floor(progress * (end - start) + start) + 'B';
        } else if (inner_html.includes('K')) {
          obj.innerHTML = Math.floor(progress * (end - start) + start) + 'K';
        } else if (inner_html.includes('%')) {
          obj.innerHTML = Math.floor((progress * (end - start) + start)*10) / 10 + '%';
        }  else {
          obj.innerHTML = Math.floor(progress * (end - start) + start);
        }
        
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }

    var scroll_check = 0;
    var animi_check = 1;
    
    jQuery(document).on( "scroll", function() {

      if ( jQuery('.countup-section').length ) {
        if(jQuery(document).scrollTop() >= jQuery('.countup-section').offset().top - jQuery(window).height() + 200) {

          if ( animi_check ) {
            scroll_check = 1;
          }
          
        } 

        if (scroll_check) {
          jQuery('.countup').each(function() {
            animateValue(jQuery(this)[0]);
          });

          scroll_check = 0;
          animi_check = 0;
        }
      }
    });

    // pardot iframe auto height
    if ( jQuery('#pardot-iframe').length ) {
      jQuery('#pardot-iframe').seamless({
        fallbackText: ''
      });
    }


    // UTM parameters
    var current_url = window.location.href;

    var current_url_array = current_url.split('?');

    if ( current_url_array.length >= 2 ) {

      var query_parameters = current_url.slice(current_url.indexOf("?") + 1);

      var query_parameters_array = query_parameters.split('&');
      var new_query_parameters = '';

      for (let i = 0; i < query_parameters_array.length; i++) {
        if ( query_parameters_array[i].includes('utm')  ) {
          if ( new_query_parameters.length > 0 ) {
            new_query_parameters += '&' + query_parameters_array[i];
          } else {
            new_query_parameters += query_parameters_array[i];
          }
          
        }
      }

      if ( new_query_parameters.length > 0 ) {

        jQuery('body a').each(function() {
          var href = jQuery(this).attr('href');
          if ( href != '' && href != 'javascript:;' && href != '#' ) {
            href = href + '?' + new_query_parameters;
          }
          jQuery(this).attr('href', href);
        });
      }
    }
    

    // case study sidebar
    jQuery(document).on( "scroll", function() {
      if (jQuery('.case-study-content-wrp').length ) {
        jQuery('.case-study-content-wrp .section-title').each(function(i) {

          if (jQuery(document).scrollTop() > ( jQuery(this).offset().top - 150 ) ) {
            var data_title = jQuery(this).attr('data-title');
            jQuery('.case-study-sidebar .sidebar-item').removeClass('active');

            jQuery('.case-study-sidebar .sidebar-item[data-title="' + data_title + '"]').addClass('active');
            
          }
        });
      }
    });

    jQuery('.case-study-sidebar .sidebar-item').click(function() {
      var data_title = jQuery(this).attr('data-title');

      jQuery('.case-study-content-wrp .section-title').each(function() {
        if ( data_title == jQuery(this).attr('data-title') ) {
          jQuery('html, body').animate({
            scrollTop: jQuery(this).offset().top - 120
          }, 500);
        }
      });
    });


    // Expanding card
    var $cell = jQuery('.atsls-expanding-card .card-item');

    //open and close card when clicked on card
    $cell.find('.js-expander').click(function() {

      var $thisCell = jQuery(this).closest('.card-item');

      if ($thisCell.hasClass('is-collapsed')) {
        $cell.not($thisCell).removeClass('is-expanded').addClass('is-collapsed').addClass('is-inactive');
        $thisCell.removeClass('is-collapsed').addClass('is-expanded');
        
        if ($cell.not($thisCell).hasClass('is-inactive')) {
          //do nothing
        } else {
          $cell.not($thisCell).addClass('is-inactive');
        }

      } else {
        $thisCell.removeClass('is-expanded').addClass('is-collapsed');
        $cell.not($thisCell).removeClass('is-inactive');
      }
    });

    //close card when click on cross
    $cell.find('.js-collapser').click(function() {

      var $thisCell = jQuery(this).closest('.card-item');

      $thisCell.removeClass('is-expanded').addClass('is-collapsed');
      $cell.not($thisCell).removeClass('is-inactive');

    });


    // ATSLS Resources Events Slider
    if ( $('.atsls-resources-events-section .events-wrp .events-slider-wrp').length) {
      $('.atsls-resources-events-section .events-wrp .events-slider-wrp').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: true,
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            dots: false
          }
        }, {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            dots: false
          }
        }]
      }); 
    } 

    // home resources section
    $('.home-resources-section .resources-btns-wrp .gb-button').click(function() {

      var resource_type = $(this).attr('data-resource-type');
      $('.home-resources-section .resources-block').removeClass('active');

      $('.home-resources-section .resources-block.' + resource_type + '-block').addClass('active');

      if ( resource_type == 'events' ) {

        if ( $('.atsls-resources-events-section .events-wrp .events-slider-wrp').length) {
          $('.atsls-resources-events-section .events-wrp .events-slider-wrp').slick('refresh');
        }

      } 

      $('.home-resources-section .resources-btns-wrp .gb-button').removeClass('active');
      $(this).addClass('active');

      return false;

    });

    jQuery('.atsls-innovation-tab .tab-item').click(function() {
      var data_tab = jQuery(this).attr('data-tab');

      jQuery('.atsls-innovation-tab .tab-item').removeClass('active');
      jQuery(this).addClass('active');

      jQuery('.atsls-innovation-tab .tab-content').removeClass('active');
      jQuery('.atsls-innovation-tab .tab-content[data-tab=' + data_tab + ']').addClass('active');
    });

    // ATSLS resources slider
    if ( $('.atsls-resources-section .each-group .inner-wrp').length) {
      $('.atsls-resources-section .each-group .inner-wrp').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }]
      });
    } 

    jQuery('.atsls-resources-section .title-part .filter-wrp a').click(function() {
      var post_type = jQuery(this).attr('data-post-type');
      jQuery('.atsls-resources-section .title-part .filter-wrp a').removeClass('active');
      jQuery(this).addClass('active');

      jQuery('.atsls-resources-section .each-group').removeClass('active');
      jQuery('.atsls-resources-section .each-group.' + post_type + '-group').addClass('active');

      if ( jQuery('.atsls-resources-section .each-group.' + post_type + '-group .inner-wrp').length) {
        jQuery('.atsls-resources-section .each-group.' + post_type + '-group .inner-wrp').slick('refresh');
      }
      
    });

    // atsls scroll section
    jQuery(document).on( "scroll", function() {
      if (jQuery('.atsls-scroll-section').length ) {
        jQuery('.atsls-scroll-section .each-card').each(function(i) {

          if (jQuery(document).scrollTop() > ( jQuery(this).offset().top - 150 ) ) {
            var data_item_index = jQuery(this).attr('data-item-index');
            jQuery('.atsls-scroll-section .images-wrp .each-image').removeClass('active');

            jQuery('.atsls-scroll-section .images-wrp .each-image[data-item-index="' + data_item_index + '"]').addClass('active');
            
          }
        });
      }
    });

    if ( $('.atsls-testimonial-slider > .gb-inside-container').length) {
      $('.atsls-testimonial-slider > .gb-inside-container').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: true
      }); 
    }

    $('.icon-play, .icon-play--white').on('click', function () {
      $(this).removeClass('icon-play icon-play--white ats-gradient');
      let video = $(this).find('video')[0];
      if (video) {
        video.setAttribute('controls', 'controls');
      }
    });


    function checkScroll() {
      let scrollPosition = $(window).scrollTop();
      let header = $('.event-header');
    
      if (header.length) { 
        if (scrollPosition > 120) {
          header.addClass('scrolled-header');
        } else {
          header.removeClass('scrolled-header');
        }
      }
    }

    checkScroll();

    $(window).on('scroll', function() {
      checkScroll();
    });



    if ( $('.innovation-hero').length) {

      jQuery(document).on( "scroll", function() {

        var offset = jQuery(document).scrollTop();


        $('.innovation-hero .video-wrp .video-mask1').css('width', Math.floor(offset/3) + 'px');
        $('.innovation-hero .video-wrp .video-mask1').css('right', 'calc(33% - ' + Math.floor(offset/6) + 'px)');

        $('.innovation-hero .video-wrp .video-mask2').css('width', Math.floor(offset/3) + 'px');
        $('.innovation-hero .video-wrp .video-mask2').css('right', 'calc(66% - ' + Math.floor(offset/12) + 'px)');

         
      });
    }

    var rellax = new Rellax('.rellax', {
      breakpoints:[576, 768, 1201]
    });

    var rellax_el = new Rellax('.rellax-el', {
      breakpoints:[576, 768, 1201]
    });

    // Innovation Scroll Section
    // if ( $('.innovation-scroll-section .inner-wrp .slider-wrp').length) {
    //   $('.innovation-scroll-section .inner-wrp .slider-wrp').slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     // vertical: true,
    //     // verticalSwiping: true,
    //     autoplay: false,
    //     autoplaySpeed: 3000,
    //     speed: 500,
    //     infinite: false,
    //     arrows: false,
    //     dots: false,
    //     fade: true
    //   });

    //   $('.innovation-scroll-section .inner-wrp .slider-wrp').on('mousewheel', function(e) {

    //     // e.preventDefault();
    //     if (e.originalEvent.deltaY < 0) {
    //       $(this).slick('slickPrev');  // Scroll up
    //     } else {
    //       $(this).slick('slickNext');  // Scroll down
    //     }
    //   });
    // }

    jQuery(document).on( "scroll", function() {

      if ( jQuery('.innovation-scroll-section').length ) {
        if(jQuery(document).scrollTop() >= jQuery('.innovation-scroll-section').offset().top - jQuery('.innovation-scroll-section').height() - 200 && jQuery(document).scrollTop() < jQuery('.innovation-scroll-section').offset().top) {

          var offset = jQuery(document).scrollTop() - jQuery('.innovation-scroll-section').offset().top + jQuery('.innovation-scroll-section').height() + 200;
          var height = jQuery('.innovation-scroll-section').height();

          var step = Math.min((offset * 0.4) / height + 0.6, 1);

          $('.innovation-scroll-section').css('transform',  'scale(' + step + ')');
          
        } 

        else if(jQuery(document).scrollTop() >= jQuery('.innovation-scroll-section .each-item:last-child').offset().top) {
          var offset = jQuery(document).scrollTop() - jQuery('.innovation-scroll-section .each-item:last-child').offset().top;
          var height = jQuery('.innovation-scroll-section .each-item:last-child').height();

          var step = Math.max((offset * (-0.4)) / height + 1, 0.6);

          $('.innovation-scroll-section').css('transform',  'scale(' + step + ')');
        }
      }


      var compensation = $(window).height() / 2;
      var scrollPos = $(document).scrollTop();
      
      
      // Apply text changes
      $('.innovation-scroll-section .slider-wrp .each-item').each(function(index){
        if($(this).next().length) {
          if ((scrollPos >= ($(this).offset().top) - compensation) && (scrollPos < ($(this).next().offset().top) - compensation)) {
            var detail = $(this).find('.detail').eq(0).html();

            console.log(detail);

            $('.innovation-scroll-section .video-wrp .section-title-underlay .detail').html(detail);
          }
        }
      });

    });

  });

})(jQuery);
